import { Description, DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { InvoiceFormField } from "./InvoiceFormField";

export const InvoiceDocument = ({ dataState, setDataState }) => {
    const { t } = useTranslation()

    return (
        <>
            <M_Fieldset
                labelInside
                label={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "25px",
                            marginLeft: "10px",
                        }}
                    >
                        <Description style={{ marginRight: "10px", scale: "1.3" }} />{" "}
                        {t("Document")}
                    </div>
                }
                elements={
                    <div

                    >
                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                <InvoiceFormField label={t("InvoiceCompany")} type="disabled" code="InvoiceCompany" data={dataState} setData={setDataState} />
                                {/* <InvoiceFormField label={t("InvoiceKey")} type="disabled" code="InvoiceKey" data={dataState} setData={setDataState} /> */}
                            </div>

                            {/* <div style={{ display: "flex", flexWrap: "wrap" }}>
                                <InvoiceFormField label={t("Per")} type="disabled" code="Per" size="70px" data={dataState} setData={setDataState} />
                                <InvoiceFormField label={t("Year")} type="disabled" code="Year" size="70px" data={dataState} setData={setDataState} />
                            </div> */}
                        </div>
                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                            <InvoiceFormField label={t("DocumentCode")} type="disabled" code="DocumentCode" data={dataState} setData={setDataState} />
                            <InvoiceFormField label={t("DocumentPrefix")} type="disabled" code="DocumentPrefix" data={dataState} setData={setDataState} />
                            <InvoiceFormField label={t("DocumentCounter")} type="disabled" code="DocumentCounter" data={dataState} setData={setDataState} />
                        </div>
                    </div>
                }
            />
        </>
    )
}